<template>
  <div class="d-flex align-center">
    <div :class="{redPoint: required,  transparentPoint: !required, 'mx-4': true}"></div>


    <v-select
        class="tablegray"
        height="66"
        :items="options"
        v-bind:value="value"
        v-on:input="updateOption"
        :label="placeholder"
        outlined
        :disabled="disabled"
        :item-disabled="disableItems"
        single-line
        hide-details
        offset-y
        :menu-props="{offsetX: true, transition: false}"
        :error="reminding"
        return-object
    >
        <template v-slot:prepend-item>
            <slot name="list-tile"></slot>
        </template>
    </v-select>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedOption: {
        name: ""
      },
      searchString: "",
      showMenu: false,
      placeholderText: "Please select an item"
    };
  },
  props: {
    options: {
      type: [Array, Object]
    },
    disableItems: {
        type: [Array],
        default: []
    },
    needSearch: {
      type: [Boolean],
      default: false
    },
    flat: Boolean,
    value: {},
    disabled: Boolean,
    reminding: Boolean,
    placeholder: [String],
    closeOnOutsideClick: {
      type: [Boolean],
      default: true
    },
    pretext: {
      type: String,
      default: ""
    },
    required: {
      type: [Boolean],
      default: false
    }
  },
  mounted() {
    this.selectedOption = this.selected;
    if (this.placeholder) {
      this.placeholderText = this.placeholder;
    }
    if (this.closeOnOutsideClick) {
      document.addEventListener("click", this.clickHandler);
    }
  },
//   beforeDestroy() {
//     document.removeEventListener("click", this.clickHandler);
//   },
  watch: {
      $props: {
        handler: function(val, oldVal, tt) {
            this.$emit("input", this.value);
        }
    },
  },
  computed: {
    searchedOption: function() {
      if (
        this.searchString == null ||
        this.searchString == "" ||
        !this.needSearch
      ) {
        return this.options;
      } else {
        this.options.filter(option => {
          return option.text.includes(this.searchString);
        });
      }
    }
  },
  methods: {
    updateOption(option) {
      this.selectedOption = option;
      this.showMenu = false;
    //   this.value = this.selectedOption.value;
      this.$emit("input", option.value);
    },
    getText(value) {
      if (value.text) {
        return value.text;
      }
      const item = this.options.find(option => {
        return option.value == value;
      });
      if (!item) {
        return this.placeholderText;
      } else {
        return item.text;
      }
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    clickHandler(event) {
      const { target } = event;
      const { $el } = this;
      if (!$el.contains(target)) {
        this.showMenu = false;
      }
    }
  }
};
</script>

<style scoped>
.btn-group {
  /* max-width: 400px; */

  /* position: relative; */
  /* display: inline-block; */
  /* vertical-align: middle; */
  /* border-width: 1px;
  border-color: #e3e3e3;
  border-style: solid; */
  background-color: #f9fafc;
}
/* .btn-group a:hover {
} */

.reminder {
  border-color: #e62e2e !important;
  border-width: 2px !important;
}

.dropdown-toggle {
  color: #636b6f;
  /* padding: 10px 20px 10px 10px; */
  /* padding: 10px; */

  font-weight: 300;
  /* margin-bottom: 7px; */
  border: 0;
  background-size: 0 2px, 100% 1px;
  background-repeat: no-repeat;
  background-position: center bottom, center calc(100% - 1px);
  background-color: transparent;
  box-shadow: none;
  border-radius: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.dropdown-toggle:hover {
  cursor: pointer;
}
.menu-content {
}
.dropdown-menu {
  max-height: 400px;
  overflow-y: scroll !important;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  float: left;
  min-width: 160px;
  /* padding: 5px 0;
  margin: 2px 0 0; */
  list-style: none;
  font-size: 14px;
  text-align: left;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-clip: padding-box;
}
.dropdown-menu > li > a {
  padding: 10px 30px;
  display: block;
  clear: both;
  font-weight: normal;
  line-height: 1.6;
  color: #333333;
  white-space: nowrap;
  text-decoration: none;
}
.dropdown-menu > li > a:hover {
  background: #efefef;
  color: #409fcb;
}
.dropdown-menu > li {
  overflow: hidden;
  width: 100%;
  position: relative;
  margin: 0;
}

li {
  list-style: none;
}

.select-contaier {
  width: 100%;
}
.redPoint {
  background-color: #e62e2e;
  border-radius: 3.5px;
  width: 7px;
  height: 7px;
}

.transparentPoint {
  background-color: transparent;
  border-radius: 3.5px;
  width: 7px;
  height: 7px;
}

.fontbold {
  /* font-family: SHBold; */
  font-weight: bold
}

.flat-caret {
  width: 0;
  position: absolute;
  height: 0;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid \9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  right: -10px;
  top: 10px;
}

.caret {
  width: 0;
  position: absolute;
  height: 0;
  margin-left: -24px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid \9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  right: 10px;
  top: 30px;
}

.flat-input-container {
  cursor: pointer;
  /* width: 100%; */
  padding-left: 8px;
  padding-right: 18px;
  color: #328dff;
  height: 28px;
  background-color: white;
  border-width: 2px;
  border-radius: 14px;
  border-color: #328dff;
  border-style: solid;
}

.input-container {
  cursor: pointer;
  height: 66px;
  width: 100%;
  background-color: #f9fafc;
  border-width: 1px;
  border-radius: 4px;
  /* border-color: #e3e3e3; */
  border-color: #bdbec0;
  border-style: solid;
}

.search-text-input {
  height: 40px;
  align-content: center;
  padding: 8px;
  border-width: 1px;
  border-color: #666666;
  border-style: solid;
  border-radius: 4px;
}

.searchText {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
  height: 40px;
}

.flat-select-text {
    margin-top: 0px;
}
.select-text {
    margin-top: 16px;
}
</style>
